import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { observer } from 'mobx-react';
import { Alert, AlertTitle } from '@material-ui/lab';
import Routes from 'routes';
import DefaultLocales from 'globals/locales/default';
import reportLocales from 'globals/locales/report';
import { ModalState } from 'globals/types';
import FsButton from 'ui-elements/buttons/FsButton';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsDialogTitle from 'ui-elements/modals/FsDialogTitle';
import {
  CustomDialog,
  DialogActions,
  DialogContent,
  RelativeSendButtonWrapperBox,
} from '../ReportModals.style-elements';
import { ReportDeleteModalLocationStateProps } from '../ReportDeleteModal/ReportDeleteModal';

const { close: closeLabel } = DefaultLocales;

const {
  dialogTitle,
  alertTitle,
  alertDescription,
} = reportLocales.deleteModalSuccess;

const ReportDeleteModalSuccess: React.FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const modalState = location.state as ReportDeleteModalLocationStateProps;
  const status = modalState?.success || false;
  const path = modalState?.path || '/';

  const redirect = useCallback((): void => {
    history.push({ pathname: Routes.REPORT });
  }, [history]);

  const redirectBackToPanel = (): void => {
    window.location.href = path;
  };

  const handleClose = (): void => {
    redirectBackToPanel();
  };

  useEffect(() => {
    if (status !== ModalState.SUCCESS) redirect();
  }, [status, redirect]);

  return (
    <CustomDialog
      disableEnforceFocus
      open
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      data-test="report-delete-modal-success"
    >
      <FsDialogTitle id="report-delete-modal-success" onClose={handleClose}>
        {dialogTitle}
      </FsDialogTitle>

      <DialogContent dividers>
        <Alert severity="success">
          <AlertTitle>
            <FsBodyBold>{alertTitle}</FsBodyBold>
          </AlertTitle>
          <FsBody>{alertDescription[0]}</FsBody>
        </Alert>
      </DialogContent>
      <DialogActions>
        <RelativeSendButtonWrapperBox>
          <FsButton onClick={handleClose} variant="contained" color="primary">
            {closeLabel}
          </FsButton>
        </RelativeSendButtonWrapperBox>
      </DialogActions>
    </CustomDialog>
  );
};

export default observer(ReportDeleteModalSuccess);
